/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_PAYEE_GET
 */
export const getTalentMemberByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getTalentMemberByIdResponseAddressAddressLine1Max = 255;

export const getTalentMemberByIdResponseAddressAddressLine2Max = 255;

export const getTalentMemberByIdResponseAddressCityMax = 255;

export const getTalentMemberByIdResponseAddressStateMax = 2;

export const getTalentMemberByIdResponseAddressZipMax = 10;

export const getTalentMemberByIdResponseAddressCountryMax = 100;





export const getTalentMemberByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "type": zod.string().nullish(),
  "skills": zod.string().nullish(),
  "experience": zod.string().nullish(),
  "bio": zod.string().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(getTalentMemberByIdResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getTalentMemberByIdResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getTalentMemberByIdResponseAddressCityMax).nullish(),
  "state": zod.string().max(getTalentMemberByIdResponseAddressStateMax).nullish(),
  "zip": zod.string().max(getTalentMemberByIdResponseAddressZipMax).nullish(),
  "country": zod.string().max(getTalentMemberByIdResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "tags": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().min(1),
  "description": zod.string().nullish(),
  "hexColor": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({})
})).nullish(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "hasCompletedIdentityVerification": zod.boolean(),
  "identityVerificationEntityType": zod.enum(['Individual', 'Business']).optional(),
  "identityVerificationBusinessName": zod.string().nullish(),
  "hasLinkedBankAccount": zod.boolean(),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "primaryDestinationType": zod.enum(['BankAccount', 'DebitCard']).optional(),
  "hasPayoutEligibleCard": zod.boolean(),
  "pushToCardEnabled": zod.boolean(),
  "verifiedEmails": zod.array(zod.object({
  "id": zod.string().uuid(),
  "email": zod.string().min(1),
  "isPrimary": zod.boolean(),
  "verifiedDate": zod.string().datetime({})
}))
})

/**
 * **Required Permission(s):** ORG_PAYEE_UPDATE
 */
export const updateTalentMemberParams = zod.object({
  "id": zod.string().uuid()
})

export const updateTalentMemberBodyFirstNameMax = 255;

export const updateTalentMemberBodyLastNameMax = 255;

export const updateTalentMemberBodyPhoneMax = 20;

export const updateTalentMemberBodyEmailMax = 255;

export const updateTalentMemberBodyTypeMax = 50;

export const updateTalentMemberBodyAddressAddressLine1Max = 255;

export const updateTalentMemberBodyAddressAddressLine2Max = 255;

export const updateTalentMemberBodyAddressCityMax = 255;

export const updateTalentMemberBodyAddressStateMax = 2;

export const updateTalentMemberBodyAddressZipMax = 10;

export const updateTalentMemberBodyAddressCountryMax = 100;



export const updateTalentMemberBody = zod.object({
  "firstName": zod.string().max(updateTalentMemberBodyFirstNameMax).nullish(),
  "lastName": zod.string().max(updateTalentMemberBodyLastNameMax).nullish(),
  "phone": zod.string().max(updateTalentMemberBodyPhoneMax).nullish(),
  "email": zod.string().max(updateTalentMemberBodyEmailMax).nullish(),
  "type": zod.string().max(updateTalentMemberBodyTypeMax).nullish(),
  "skills": zod.string().nullish(),
  "experience": zod.string().nullish(),
  "bio": zod.string().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(updateTalentMemberBodyAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(updateTalentMemberBodyAddressAddressLine2Max).nullish(),
  "city": zod.string().max(updateTalentMemberBodyAddressCityMax).nullish(),
  "state": zod.string().max(updateTalentMemberBodyAddressStateMax).nullish(),
  "zip": zod.string().max(updateTalentMemberBodyAddressZipMax).nullish(),
  "country": zod.string().max(updateTalentMemberBodyAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "tags": zod.array(zod.string().uuid()).nullish(),
  "isActive": zod.boolean()
})

export const updateTalentMemberResponseAddressAddressLine1Max = 255;

export const updateTalentMemberResponseAddressAddressLine2Max = 255;

export const updateTalentMemberResponseAddressCityMax = 255;

export const updateTalentMemberResponseAddressStateMax = 2;

export const updateTalentMemberResponseAddressZipMax = 10;

export const updateTalentMemberResponseAddressCountryMax = 100;





export const updateTalentMemberResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "type": zod.string().nullish(),
  "skills": zod.string().nullish(),
  "experience": zod.string().nullish(),
  "bio": zod.string().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(updateTalentMemberResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(updateTalentMemberResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(updateTalentMemberResponseAddressCityMax).nullish(),
  "state": zod.string().max(updateTalentMemberResponseAddressStateMax).nullish(),
  "zip": zod.string().max(updateTalentMemberResponseAddressZipMax).nullish(),
  "country": zod.string().max(updateTalentMemberResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "tags": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().min(1),
  "description": zod.string().nullish(),
  "hexColor": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({})
})).nullish(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "hasCompletedIdentityVerification": zod.boolean(),
  "identityVerificationEntityType": zod.enum(['Individual', 'Business']).optional(),
  "identityVerificationBusinessName": zod.string().nullish(),
  "hasLinkedBankAccount": zod.boolean(),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "primaryDestinationType": zod.enum(['BankAccount', 'DebitCard']).optional(),
  "hasPayoutEligibleCard": zod.boolean(),
  "pushToCardEnabled": zod.boolean(),
  "verifiedEmails": zod.array(zod.object({
  "id": zod.string().uuid(),
  "email": zod.string().min(1),
  "isPrimary": zod.boolean(),
  "verifiedDate": zod.string().datetime({})
}))
})

/**
 * **Required Permission(s):** ORG_PAYEE_DELETE
 */
export const deleteTalentMemberParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_PAYEE_LIST
 */
export const listTalentMembersQueryPageDefault = 1;export const listTalentMembersQueryPageSizeDefault = 25;

export const listTalentMembersQueryParams = zod.object({
  "page": zod.number().default(listTalentMembersQueryPageDefault),
  "pageSize": zod.number().default(listTalentMembersQueryPageSizeDefault),
  "search": zod.string().optional()
})

export const listTalentMembersResponseItemsItemAddressAddressLine1Max = 255;

export const listTalentMembersResponseItemsItemAddressAddressLine2Max = 255;

export const listTalentMembersResponseItemsItemAddressCityMax = 255;

export const listTalentMembersResponseItemsItemAddressStateMax = 2;

export const listTalentMembersResponseItemsItemAddressZipMax = 10;

export const listTalentMembersResponseItemsItemAddressCountryMax = 100;





export const listTalentMembersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "type": zod.string().nullish(),
  "skills": zod.string().nullish(),
  "experience": zod.string().nullish(),
  "bio": zod.string().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(listTalentMembersResponseItemsItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(listTalentMembersResponseItemsItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(listTalentMembersResponseItemsItemAddressCityMax).nullish(),
  "state": zod.string().max(listTalentMembersResponseItemsItemAddressStateMax).nullish(),
  "zip": zod.string().max(listTalentMembersResponseItemsItemAddressZipMax).nullish(),
  "country": zod.string().max(listTalentMembersResponseItemsItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "tags": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().min(1),
  "description": zod.string().nullish(),
  "hexColor": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({})
})).nullish(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "hasCompletedIdentityVerification": zod.boolean(),
  "identityVerificationEntityType": zod.enum(['Individual', 'Business']).optional(),
  "identityVerificationBusinessName": zod.string().nullish(),
  "hasLinkedBankAccount": zod.boolean(),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "primaryDestinationType": zod.enum(['BankAccount', 'DebitCard']).optional(),
  "hasPayoutEligibleCard": zod.boolean(),
  "pushToCardEnabled": zod.boolean(),
  "verifiedEmails": zod.array(zod.object({
  "id": zod.string().uuid(),
  "email": zod.string().min(1),
  "isPrimary": zod.boolean(),
  "verifiedDate": zod.string().datetime({})
}))
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_TALENT_SET_PUSH_TO_CARD
 */
export const setTalentMemberPushToCardParams = zod.object({
  "id": zod.string().uuid()
})

export const setTalentMemberPushToCardBody = zod.object({
  "enabled": zod.boolean()
})

export const setTalentMemberPushToCardResponseAddressAddressLine1Max = 255;

export const setTalentMemberPushToCardResponseAddressAddressLine2Max = 255;

export const setTalentMemberPushToCardResponseAddressCityMax = 255;

export const setTalentMemberPushToCardResponseAddressStateMax = 2;

export const setTalentMemberPushToCardResponseAddressZipMax = 10;

export const setTalentMemberPushToCardResponseAddressCountryMax = 100;





export const setTalentMemberPushToCardResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "type": zod.string().nullish(),
  "skills": zod.string().nullish(),
  "experience": zod.string().nullish(),
  "bio": zod.string().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(setTalentMemberPushToCardResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(setTalentMemberPushToCardResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(setTalentMemberPushToCardResponseAddressCityMax).nullish(),
  "state": zod.string().max(setTalentMemberPushToCardResponseAddressStateMax).nullish(),
  "zip": zod.string().max(setTalentMemberPushToCardResponseAddressZipMax).nullish(),
  "country": zod.string().max(setTalentMemberPushToCardResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "tags": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().min(1),
  "description": zod.string().nullish(),
  "hexColor": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({})
})).nullish(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "hasCompletedIdentityVerification": zod.boolean(),
  "identityVerificationEntityType": zod.enum(['Individual', 'Business']).optional(),
  "identityVerificationBusinessName": zod.string().nullish(),
  "hasLinkedBankAccount": zod.boolean(),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "primaryDestinationType": zod.enum(['BankAccount', 'DebitCard']).optional(),
  "hasPayoutEligibleCard": zod.boolean(),
  "pushToCardEnabled": zod.boolean(),
  "verifiedEmails": zod.array(zod.object({
  "id": zod.string().uuid(),
  "email": zod.string().min(1),
  "isPrimary": zod.boolean(),
  "verifiedDate": zod.string().datetime({})
}))
})

/**
 * **Required Permission(s):** ORG_PAYEE_GET
 */
export const getTalentMemberPayoutTermsParams = zod.object({
  "id": zod.string().uuid()
})

export const getTalentMemberPayoutTermsResponse = zod.object({
  "payoutPolicyId": zod.string().uuid().nullish(),
  "payoutPolicyName": zod.string().nullish(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional(),
  "isOnLegacyTerms": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_PAYEE_ASSIGN_PAYOUT_POLICY
 */
export const assignTalentMemberPayoutPolicyParams = zod.object({
  "id": zod.string().uuid()
})

export const assignTalentMemberPayoutPolicyBody = zod.object({
  "payoutPolicyId": zod.string().uuid()
})

export const assignTalentMemberPayoutPolicyResponse = zod.object({
  "payoutPolicyId": zod.string().uuid().nullish(),
  "payoutPolicyName": zod.string().nullish(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional(),
  "isOnLegacyTerms": zod.boolean()
})

